// "59.00" → "59 zł", "14.99" → "14,99 zł"
export function formatPrice(price) {
  const [zl, gr = '00'] = String(price).split('.');
  return gr === '00' ? `${zl} zł` : `${zl},${gr.padEnd(2, '0')} zł`;
}

export function employerPlans(plans) {
  return plans
    .filter(p => p.user_type === 'employer' && p.scope === 'main')
    .sort((a, b) => Number(a.price) - Number(b.price));
}

// Pakiet wyróżniony na stronie jako „Najczęściej wybierany” (M)
export const FEATURED_PRICE = 99;
